import { useEffect, useRef, useLayoutEffect } from 'react';
import { gql, useLazyQuery, useQuery } from '@apollo/client';

const gqlGetOptions = gql`
  query getOptions {
    getOptions {
      UseMultiWRSLocations
      WBProd_Pres_DefStoreLoc
      WBDeliv_DefStoreLoc
      UseTraceItems
      UseInvSapExcel
    }
  }
`;

export function useOptions() {
  const { data } = useQuery(gqlGetOptions, {
    fetchPolicy: 'cache-and-network',
  });

  return { options: data?.getOptions };
}

